/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IVisitable } from '../../core/models/IVisitable';

/**
 * An OpenAPI property schema.
 * @author eric.wittmann@gmail.com
 * @class
 */
export interface IOasPropertySchema extends IVisitable {
    /**
     * Returns the property schema's name.
     * @return {string}
     */
    getPropertyName() : string;

    /**
     * Renames the property schema.
     * @param {string} newName
     */
    rename(newName : string);
}


